<template>
    <div>
        <div class="row">
            <div class="col-md-5 pb-2">
              <div class="form-group position-relative">
                <input type="text" class="form-control" name="invoiceNr" v-model="search_review"  placeholder="Inseratstitel, Nummer, Nickname" v-on:keyup.enter="fetchAssesments()" />
                <font-awesome-icon icon="search" class="search mm-color" @click="fetchAssesments()"/>
              </div>
            </div>

            <div class="col-md-2 pb-2">
              <div class="form-group position-relative input-group">
                <input type="button" class="w-100 btn btn-light filter-icon" name="filter" value="Filter" @click="OpenfiltersModal()" />
              </div>
            </div>
            <div class="col-md-5 pb-2 float-right">
              <select v-model="sort_input" class=" form-control">
                <option value="1"> Sortieren: Neueste zuerst </option>
                <option value="0" >Sortieren: Älteste zuerst</option>
              </select>
            </div>
        </div>

        <b-modal ref="modal" title="Filter" :size="'lg'">
            <div class="m-4">
                <div class="row">
                  <b>Sterne</b>
                </div>
                <div class="row mt-2" >
                  <div class="col-md-2">
                    <input type="radio" id="1-star" value="1" v-model="stars_input" class="form-check-input"/>
                    <label class="form-check-label" for="1-star">1 Sterne</label>
                  </div>
                  <div class="col-md-2">
                    <input type="radio" id="2-star" value="2" v-model="stars_input" class="form-check-input"/>
                    <label class="form-check-label" for="2-star">2 Sterne</label>
                  </div>
                  <div class="col-md-2">
                    <input type="radio" id="3-star" value="3" v-model="stars_input" class="form-check-input"/>
                    <label class="form-check-label" for="3-star">3 Sterne</label>
                  </div>
                  <div class="col-md-2">
                    <input type="radio" id="4-star" value="4" v-model="stars_input" class="form-check-input"/>
                    <label class="form-check-label" for="4-star">4 Sterne</label>
                  </div>
                  <div class="col-md-2">
                    <input type="radio" id="5-star" value="5" v-model="stars_input" class="form-check-input"/>
                    <label class="form-check-label" for="5-star">5 Sterne</label>
                  </div>
                </div>
            </div>
            <hr/>
            <div class="m-4">

                <div class="row">
                  <b>Antwort</b>
                </div>
                <div class="row mt-2">
                  <div class="col-md-3">
                    <input type="radio" id="beantwortet" value="1" v-model="answered_input" class="form-check-input "/>
                    <label class="form-check-label" for="beantwortet">beantwortet</label>
                  </div>
                  <div class="col-md-3">
                    <input type="radio" id="unbeantwortet" value="0" v-model="answered_input" class="form-check-input "/>
                    <label class="form-check-label" for="unbeantwortet">unbeantwortet</label>
                  </div>
                </div>
            </div>
            <hr/>
            <div class="m-4">
                <div class="row">
                  <b>Status</b>
                </div>
                <div class="row mt-2">
                  <div class="col-md-3">
                    <input type="radio" id="veröffentlicht" value="1" v-model="status_input" class="form-check-input"/>
                    <label class="form-check-label" for="veröffentlicht">veröffentlicht</label>
                  </div>
                  <div class="col-md-4">
                    <input type="radio" id="nicht-veröffentlicht" value="0" v-model="status_input" class="form-check-input"/>
                    <label class="form-check-label" for="nicht-veröffentlicht">nicht veröffentlicht</label>
                  </div>
                  <div class="col-md-3">
                    <input type="radio" id="gemeldet" value="2" v-model="status_input" class="form-check-input"/>
                    <label class="form-check-label" for="gemeldet">gemeldet</label>
                  </div>
                </div>
            </div>
            <template slot="modal-footer">
                <b-button variant="secondary" @click="deleteFilters">Filter löschen</b-button>
                <b-button variant="success" @click="clearModal">Fertig</b-button>
            </template>
        </b-modal>
    </div>
</template>

<script>
    import StarsComponent from '../shared/Stars';

    export default {
        data() {
            return {
                sort_input: 1,
                stars_input: this.stars,
                answered_input: this.answered,
                report_input: this.report,
                status_input: this.status,
                search_review : ''
            }
        },
        components: {
            StarsComponent
        },
        props: ['sort', 'stars', 'answered', 'report', 'status'],
        methods: {
          OpenfiltersModal() {
            this.$refs.modal.show();
          },
          clearModal() {
            this.$refs.modal.hide();
          },
          deleteFilters() {
            this.stars_input = '';
            this.answered_input = '';
            this.status_input = '';
            this.answered_input = '';
            this.$refs.modal.hide();
          },
          fetchAssesments() {
            this.$emit('search', this.search_review);
          }
        },
        watch: {
            sort_input(val) {
                if(this.sort != val) {
                    this.$emit('sort', val);
                }
            },
            stars_input(val) {
                if(this.stars != val) {
                    this.$emit('filter', ['stars', val]);
                }
            },
            answered_input(val) {
                if(this.answered != val) {
                    this.$emit('filter', ['answered', val]);
                }
            },
            report_input(val) {
                if(this.report != val) {
                    this.$emit('filter', ['report', val]);
                }
            },
            status_input(val) {
                if(this.status != val) {
                    this.$emit('filter', ['status', val]);
                }
            },
            sort(val) {
                this.sort_input = val;
            },
            stars(val) {
                this.stars_input = val;
            },
            answered(val) {
                this.answered_input = val;
            },
            report(val) {
                this.report_input = val;
            },
            status(val) {
                this.status_input = val;
            },
        }
    }
</script>

<style scoped>
.search{
    width: 15px;
    height: 15px;
    position: absolute;
    top: 12px;
    right: 10px;
    cursor: pointer;
}
.form-control{
  border : 2.3px solid #808080 !important;
  border-radius: 5px !important;
}
.btn-light{
  border : 2.3px solid #808080 !important;
  border-radius: 5px !important;
}
.filter-icon{
    width: 95px;
    text-align: left;
    background-image: url(/img/intern/filter.svg);
    background-repeat: no-repeat;
    background-position: right;
    background-position-x: 95%;
}
</style>
